import { QuoteModel } from '../model/quote.model'
import { formatDateString } from '../utils/misc'
import { transformAPIProductToProduct } from './product.transforms'

export const transformQuote = ({
  quoteLines,
  ...quoteResource
}: QuoteModel) => ({
  ...quoteResource,
  formattedCreationDate: formatDateString(quoteResource.quoteCreationDate),
  formattedLastUpdateDate: formatDateString(quoteResource.lastUpdateDate),
  formattedRequestedDeliveryDate: formatDateString(
    quoteResource.requestedDeliveryDate,
  ),
  formattedValidFromDate: formatDateString(quoteResource.validFrom),
  formattedValidUntilDate: formatDateString(quoteResource.validUntil),

  quoteLines: quoteLines.map(({ product, ...quoteLine }) => ({
    ...quoteLine,
    product: transformAPIProductToProduct(product),
  })),
})

export const transformQuotes = (
  quoteResources: QuoteModel[],
): TransformedQuote[] => quoteResources.map(transformQuote)

export type TransformedQuote = ReturnType<typeof transformQuote>
